import * as actions from './actions'
import * as getters from './getters'
import { SHOW_MESSAGE } from './mutation-types'

const mutations = {
  [SHOW_MESSAGE] (state, message) {
    state.message = message
    localStorage.setItem('message', JSON.stringify(message))
  }
}

export default {
  state: {
    message: JSON.parse(localStorage.getItem('message'))
  },
  actions,
  getters,
  mutations
}
